import TextImageBanner from '../../common/TextImageBanner';
import PriceCardSection from './PriceCardSection';
import envelope from '../../../Assets/Images/envelope.png'
import image from "../../../Assets/Home/MainHome/home3.png"
const PriceTable = () => {
  return (
    <section className='tracking-wide bg-[#F9FAFB] jakarta-font'>
      <TextImageBanner label={"Package"} bgImage={image} />
      <PriceCardSection />
      <div className='px-6 md:px-10 py-6'>
        <figure className='w-full'>
          <img className='w-full' src={envelope} alt="" />
        </figure>
      </div>
    </section>
  )
}

export default PriceTable
